export default __webpack_public_path__ + "static/media/Oval.1026ff57.svg";